import React, { useEffect} from "react";
import { Table  } from 'antd';
import Card from "components/card";
import Button from "components/button";
import CrudOption from "components/dropdown/crudoption";
import { PlusOutlined } from '@ant-design/icons';
import { connect } from "react-redux";
import { getAccessGroupUserList, doAccessGroupUserDelete } from "../../../../../redux/accessgroupuser/accessGroupUserState";
import { handleTableChange } from "../../../../../utils/index";
import ColumnSearchFilter from 'components/search/ColumnSearchFilter';
import SearchFilter from "components/search/SearchFilter";

const AccessGroupUserTable = ({ parentId, recordList, pagination, doSearch, filters, doDelete, ...props }) => {
  	const { getColumnSearchProps } = ColumnSearchFilter();
  	const columns = [
		{
	        title: `Username`,
	        dataIndex: 'user',
	        key: 'username',
	        width: '18%',
			sorter: true,
			...getColumnSearchProps('name'),
	        render:(user) => <span>{user?.name}</span> 
	    },
	    {
	        title: `Email`,
	        dataIndex: 'user',
	        key: 'email',
	        width: '20%',
	        sorter: true,
	        ...getColumnSearchProps('email'),
	        render:(user) => <span>{user?.email}</span>
	    },
	    {
	        title: <Button extra="btn-small">
			      		<a href={`/console/access-group-users/add`}>
					        <PlusOutlined />{' '}Add
					  	</a>
			    	</Button>,
	        dataIndex: 'agu_id',
	        key: 'agu_id',
	        width: '12%',
	        render:(agu_id) => <CrudOption baseRoute="/console/access-group-users" recordId={agu_id} deleteHandler={doDelete}/>
	    },
    ];
    
	useEffect(() => {
	    doSearch({paginate: pagination.per_page, groupId: parentId});
    }, [doSearch, pagination.per_page, parentId]);

  	return (
	    <Card extra={"w-full h-full p-4"} {...props}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		
	      		<SearchFilter placeholder="Search in Group or Module" searchHandler={doSearch} filters={filters} pagination={pagination}/>
	      		
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.acr_id}
		        	pagination={pagination}    
		            onChange={handleTableChange(doSearch, filters)}               	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.accessGroupUser.accessGroupUserList?.items,
  	pagination: state.accessGroupUser.accessGroupUserList?.pagination,
	filters: state.accessGroupUser.accessGroupUserList?.filters,
  	requesting: state.accessGroupUser.accessGroupUserList?.requesting,
  	error: state.accessGroupUser.accessGroupUserList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getAccessGroupUserList(filters)),
  	doDelete: (id) => dispatch(doAccessGroupUserDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccessGroupUserTable);